import UiDetail from "./UiDetail";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumPipe } from "@/models/EnumPipe";
import UiGroup from "./UiGroup";

/**
 * 国家详细
 * @description 自动生成的代码,请勿修改
 */
export default class DtoDetailParamCountry extends UiDetail<string> {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 中文名称
     */
    NameZh?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 代码
     */
    Code?: string;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 国旗
     */
    Flag?: string;
    /**
     * 地区深度
     */
    AreaDeep?: number;
    /**
     * 地区名称1
     */
    AreaName1?: string;
    /**
     * 地区名称2
     */
    AreaName2?: string;
    /**
     * 地区名称3
     */
    AreaName3?: string;
    /**
     * 地区名称4
     */
    AreaName4?: string;
    /**
     * 地区名称5
     */
    AreaName5?: string;
}

/**
 * 国家详细-表单校验
 */
export const DtoDetailParamCountryRules = {
}

/**
 * 国家详细-设置项
 */
export const DtoDetailParamCountryMiezzDetailItems: MiezzFormItem[] = [
  {
    Prop: "NameZh",
    Label: "中文名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Code",
    Label: "代码",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "FullName",
    Label: "全名",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Flag",
    Label: "国旗",
    Customize: true,
  },
  {
    Prop: "AreaDeep",
    Label: "地区深度",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "AreaName1",
    Label: "地区名称1",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "AreaName2",
    Label: "地区名称2",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "AreaName3",
    Label: "地区名称3",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "AreaName4",
    Label: "地区名称4",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "AreaName5",
    Label: "地区名称5",
    Type: EnumMiezzFormItemType.Text,
  },
]
